import Vue from "vue";
//@ts-ignore
import { swiper, swiperSlide } from 'vue-awesome-swiper';
//@ts-ignore
import { library } from '@fortawesome/fontawesome-svg-core';
//@ts-ignore
import { fas } from '@fortawesome/free-solid-svg-icons';
//@ts-ignore
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
//@ts-ignore
library.add(fas);
// @ts-ignore
Vue.component('font-awesome-icon', FontAwesomeIcon);
export default Vue.extend({
    name: 'ImageGallery',
    components: {
        swiper,
        swiperSlide
    },
    props: {
        content: {
            type: Object,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            swiperOptions: {
                slidesPerView: 3,
                spaceBetween: 30,
            }
        };
    },
    computed: {
        imageBase() {
            // @ts-ignore
            return process.env.API_BASE;
        }
    },
    methods: {
        slidePrev() {
            this.$refs.swiper.swiper.slidePrev();
        },
        slideNext() {
            this.$refs.swiper.swiper.slideNext();
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./src/pagebuilder-components/ImageGallery/ImageGallery.ts
// module id = null
// module chunks = 